export default __webpack_public_path__ + "static/media/satisfaction.04b5840d.png";